import { type SelectionState } from '../state/types';

export function createInitialSelectionState(): SelectionState {
  return {
    mode: 'idle',
    selections: [],
    focusedCell: null,
    lastInteractionSource: null,
    isEditing: false,
  };
}
